import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LayoutLibrary } from '..'
import { UseTimeZone } from '../../common/hooks/useTimeZone'
import { Element } from '../../common/html/element'
import { Loading } from '../../common/loading'
import { Table } from '../../common/table'
import { PaginationTableDownload } from './components/Panigation'
import { HeaderDownloadedFiles } from './headerDownloadFiles'
import { Header } from './headerDownloadFiles/Header'
import { handleDateTo } from './helper'
import classes from './index.module.scss'
import { getSchemaTableDownloadedFiles } from './schemaTableDownloadedFiles'
import {
  changeFilter,
  resetStore,
  selectDataTable,
  selectFilter,
  selectIds,
  selectLoadingDownLoadList,
} from './store/slice'
import {
  getDownloadFile,
  getFileCategory,
  getHeaderDownloadFile,
  getTypeReportFileFormat,
} from './store/thunk'

const DownloadedFiles = () => {
  const dispatch = useDispatch()
  const timezone = UseTimeZone()

  const ids = useSelector(selectIds)
  const filter = useSelector(selectFilter())
  const isLoadingTable = useSelector(
    selectLoadingDownLoadList('getDownloadFile'),
  )
  const isLoadingCategory = useSelector(
    selectLoadingDownLoadList('getFileCategory'),
  )
  const isLoadingFileFormat = useSelector(
    selectLoadingDownLoadList('getTypeReportFileFormat'),
  )
  const locale = useSelector((state) => state.i18n.locale)

  const handleChangeSort = (sort) => {
    dispatch(
      changeFilter({
        sort: sort?.sortBy,
        sortDirection: sort?.sortDirection,
        Page: 1,
      }),
    )
  }

  useEffect(() => {
    dispatch(getTypeReportFileFormat())
    dispatch(getFileCategory())
    dispatch(getHeaderDownloadFile())
    return () => {
      dispatch(resetStore())
    }
  }, [locale])

  useEffect(() => {
    const formatParams = {
      ...filter,
      DownLoadDateTo: filter?.DownLoadDateTo
        ? handleDateTo(new Date(filter?.DownLoadDateTo), timezone)
        : undefined,
      ExpiryDateTo: filter?.ExpiryDateTo
        ? handleDateTo(new Date(filter?.ExpiryDateTo), timezone)
        : undefined,
    }
    dispatch(getDownloadFile(formatParams))
  }, [JSON.stringify(filter), locale])

  return (
    <LayoutLibrary
      renderTopComponent={() => (
        <div style={{ padding: '0 6px' }}>
          <Header />
        </div>
      )}
      renderBottomComponent={() => (
        <>
          {isLoadingCategory || isLoadingFileFormat ? (
            <Loading />
          ) : (
            <div
              className={classes.downloadFilesMain}
              style={{ padding: '0 6px' }}
            >
              <div className="positionRelative">
                {isLoadingCategory || isLoadingFileFormat ? (
                  <Loading />
                ) : (
                  <HeaderDownloadedFiles />
                )}
              </div>
              <Element
                style={{ borderColor: '#E5E5E8' }}
                className={classes.table}
              >
                {isLoadingTable ? (
                  <Loading />
                ) : (
                  <Table
                    ids={ids}
                    getDataFromRedux={selectDataTable}
                    schema={getSchemaTableDownloadedFiles()}
                    noDataText="library.downloadedFiles.NO_DATA_DOWNLOAD"
                    isNoDataWithHead
                    sort={{
                      sortBy: filter?.sort,
                      sortDirection: filter?.sortDirection,
                    }}
                    changeSort={handleChangeSort}
                    renderPagination={() => <PaginationTableDownload />}
                    isCenterNoData={false}
                  />
                )}
              </Element>
            </div>
          )}
        </>
      )}
    />
  )
}

export default DownloadedFiles
